<template>
  <div class="system-messages-container">
    <system-message
      v-for="(m, idx) in messages"
	  :is-html="m.isHtml"
      :id="m.id"
      :key="m.id"
      :customEvents="m.customEvents"
      :message="m.message"
      :messageType="m.messageType"
      :timeout="m.timeout"
      :title="m.title"
    ></system-message>
    <v-overlay v-if="hasOverlayInStack" z-index="6"></v-overlay>
  </div>
</template>

<script>
export default {
  name: 'SystemMessages',
  props: {
    messages: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasOverlayInStack() {
      return this.messages.some(m => m.showOverlay);
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/settings/_variables';

.system-messages-container {
  & ::v-deep .v-snack {
    display: flex;
    font-size: 0.875rem;
    justify-content: center;
    left: 0;
    pointer-events: none;
    right: 0;
    top: 0;
    width: 100%;

    &:not(.v-snack--absolute) {
      height: auto;
      position: relative;
      z-index: 1000;
    }

    &:first-child {
      margin-top: 80px;

      @media #{map-get($display-breakpoints, 'sm-and-down')} {
        margin-top: 72px;
      }
    }
    & .v-snack__action {
      align-self: start !important;
      margin: 0.6875rem 0.6875rem 0 0;
    }
    &.v-snack--vertical .v-snack__action {
      margin: 0;
      padding: 0 1.5rem 1rem 3.5rem;
      width: 100%;

      & .v-snack__btn {
        width: 100%;
      }
    }
  }
}
</style>
